<template>
  <div id="app">
    <top/>

    <banner/>
    <router-view/>
    <bottom/>
  </div>
</template>
<script>
import top from './components/top.vue'
import banner from './components/banner.vue'
import bottom from './components/bottom.vue';

// import Top from './components/top.vue'
export default {
  name: 'App',
  components: {
    top,
    banner,
    bottom
  

  },
  mounted() {
    // console.log('app mounted');
  }
}
</script>

<style lang="scss">
*{
  margin: 0;
  padding: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  overflow-x: hidden; /* 防止水平滚动 */
  display: flex;
  flex-direction: column;
}

/* PC端保持最小高度 */
@media (min-width: 769px) {
  #app {
    min-height: 100vh;
  }
}

/* 移动端调整 */
@media (max-width: 768px) {
  #app {
    min-height: 100vh;
  }
  
  /* 确保所有子元素不会超出屏幕宽度 */
  * {
    box-sizing: border-box;
    max-width: 100%;
  }
}
</style>
